import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((_theme) => ({
	root: {
		display: 'flex',
		width: '100%'
	},
	main: {
		flexGrow: 1,
		minWidth: 0,
		overflow: 'hidden'
	}
}));
